export const getUniqueInitialLetters = (data: string[]): string[] => {
  const initialLetters = new Set<string>();

  data?.forEach((item) => {
    const initialLetter = item.charAt(0).toUpperCase();
    initialLetters.add(initialLetter);
  });

  return Array.from(initialLetters).sort();
};

export const getUniqueInitialLettersData = <T,>(
  data: T[],
  valueKey: keyof T
): { [key: string]: T[] } => {
  const initialLetters: { [key: string]: T[] } = {};

  data?.forEach((item) => {
    const value = item[valueKey] as string;
    const initialLetter = value.charAt(0).toUpperCase();
    if (!initialLetters[initialLetter]) {
      initialLetters[initialLetter] = [];
    }
    initialLetters[initialLetter].push(item);
  });

  return initialLetters;
};
